import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"

import DevInspectorUI from "@frog/source/views/dev/DevInspectorUI.jsx"
import {DevPaletteUI, DevNavigatorUI, DevSavestatesNavigatorUI} from "@frog/source/views/dev/DevNavigatorUI.jsx"
import DevObjectsListUI from "@frog/source/views/dev/DevObjectsListUI.jsx"

import "@frog/source/views/dev/DevPanes.less"

export default class DevPanes {
    render() {
        if(Dev.isInspectorShowing() != true) {
            return this.props.children
        }
        let navigatorPane =  (<DevPaletteUI/>)
        if(Dev.navigatorTab == "assets") {
            navigatorPane = (<DevPaletteUI/>)
        }
        if(Dev.navigatorTab == "chapters") {
            navigatorPane = (<DevNavigatorUI/>)
        }
        if(Dev.navigatorTab == "savestates") {
            navigatorPane = (<DevSavestatesNavigatorUI/>)
        }
        if(Dev.navigatorTab == "objects") {
            navigatorPane = (<DevObjectsListUI/>)
        }
        let inspectorPane = (<DevInspectorUI/>)
        const NOTIFICATION_DURATION = 2000
        let devNotification = ""
        if(Dev.notification?.message != undefined
        && Date.now() - Dev.notification.startTime < NOTIFICATION_DURATION) {
            devNotification = Dev.notification.message
        }

        let pointerReadout = (
            <span class="PointerPosition">
                {App.game?.chapter?.selection?.position?.x || 0}
                <span>x</span>
                {App.game?.chapter?.selection?.position?.y || 0}
            </span>
        )
        if(Dev.mode == "geography"
        && App.game?.chapter?.selection?.position != undefined) {
            const pointerX = Math.floor(App.game.chapter.selection.position.x + 0.5)
            const pointerY = Math.floor(App.game.chapter.selection.position.y + 0.5)
            const pointerZ = Math.floor(Dev.devSelection.z)
            const pointerChannels = Object.values(Dev.loadedProtostage.world.blocks).filter((block) => block.position.x == pointerX && block.position.y == pointerY && block.position.z == pointerZ)
            const tileTypes = pointerChannels.map((block) => {
                if(block.tileKey == undefined) return
                if(block.channelKey != undefined) return block.channelKey + ":" + block.tileKey
                if(block.tileKey == "not-found") return "not-found:" + block.tilegid
                return block.tileKey
            }).filter((string) => string != undefined)
            pointerReadout = (
                <span class="PointerPosition">
                    {pointerX || 0}
                    <span>x</span>
                    {pointerY || 0}
                    <span>x</span>
                    {pointerZ || 0}
                </span>
            )
        }
        let objectHeaderText = "Objects"
        if(Dev.mode == "geography") objectHeaderText = "Encounters"
        if(Dev.mode == "scripts") objectHeaderText = "Scripts"

        return (
            <div class="DevPanes" key="dev">
                <DevHeader/>
                <div class="DevBody">
                    <div class="TabbedPane">
                        <div class="DevPaneTabs">
                            <div class="Tab" isSelected={(Dev.navigatorTab == "chapters") + ""} onClick = {() => {Dev.navigatorTab = "chapters"; Dev.storeDevSettings()}}>Chapters</div>
                            <div class="Tab" isSelected={(Dev.navigatorTab == "assets") + ""} onClick = {() => {Dev.navigatorTab = "assets"; Dev.storeDevSettings()}}>Assets</div>
                            <div class="Tab" isSelected={(Dev.navigatorTab == "savestates") + ""} onClick = {() => {Dev.navigatorTab = "savestates"; Dev.storeDevSettings()}}>Savestates</div>
                            <div class="Tab"
                                isSelected={(Dev.navigatorTab == "objects") + ""}
                                onClick = {() => {Dev.navigatorTab = "objects"; Dev.storeDevSettings()}}>
                                {objectHeaderText}
                            </div>
                        </div>
                        {navigatorPane}
                    </div>
                    <div class="DevPlaySection">
                        {this.header}
                        <div class="DevPreview">
                            {this.props.children}
                        </div>
                        <div class="DevPlayFooter" inProtoMode={Dev.inProtoMode}>
                            {pointerReadout}
                            <span class="RandomSeed">
                                <div onClick={() => navigator.clipboard.writeText(window.location.origin + (window.location.path || "") + "?seed=" + App.game.chapter.random.seed)}>
                                    , Seed: {App.game?.chapter?.random?.seed || "unseeded"}
                                </div>
                            </span>
                            <div class="Spacer"/>
                            <span>
                                {devNotification}
                            </span>
                            <div class="Spacer"/>
                            <span class="Mode">
                                {Dev.inProtoMode ? "EDIT" : "PLAY"}
                            </span>
                        </div>
                    </div>
                    {inspectorPane}
                </div>
            </div>
        )
    }
    onClickUnitsTab() {
        return () => {
            if(Dev.inspectorTab == "units") {
                App.game.chapter.selection.unselect()
            }
            Dev.inspectorTab = "units"
            Dev.storeDevSettings()
        }
    }
    onClickPausePlayButton() {
        Dev.inProtoMode = !Dev.inProtoMode
        if(Dev.inProtoMode == false) {
            Dev.reloadSavestate("livePlaytest", {"rejectStaleSavestates": true})
        }
    }
    onClickStopButton() {
        if(App.game.chapter == undefined) return
        localStorage.removeItem("savestate_" + App.game.slug + "_" + App.game.chapter.slug + "_livePlaytest")
        App.game.chapter.restart()
        Dev.inProtoMode = !Dev.inProtoMode
    }
    get header() {
        if(Navigation.state?.screen == "DevUiScreen") {
            return (
                <div class="DevPlayHeader" inProtoMode={Dev.inProtoMode}>
                    <div class="PausePlayButton" onClick={() => Navigation.state.startTime = Date.now()}>
                        <span class="material-symbols-rounded">play_arrow</span>
                        <span class="Label">Restart</span>
                    </div>
                </div>
            )
        }

        return (
            <div class="DevPlayHeader" inProtoMode={Dev.inProtoMode}>
                <div class="PausePlayButton"
                    title={Dev.inProtoMode ? "Play" : "Pause"}
                    onClick={this.onClickPausePlayButton}>
                    <span class="material-symbols-rounded">
                        {Dev.inProtoMode ? "play_arrow" : "pause"}
                    </span>
                </div>
                <div class="StopButton"
                    title={Dev.inProtoMode ? "Restart" : "Stop"}
                    onClick={this.onClickStopButton}>
                    <span class="material-symbols-rounded">
                        {Dev.inProtoMode ? "refresh" : "stop"}
                    </span>
                </div>
            </div>
        )
    }
}

class DevHeader {
    render() {
        return (
            <div class="DevHeader">
                <div class="Dropdown" onClick={this.onClickingFileMenu()} isFileMenuActive={Dev.isFileMenuActive}>
                    <div class="Dropbutton">
                        File
                    </div>
                    <div class="DropdownContent">
                        <div class="Option" onClick={async () => {await Dev.pickEditorDirectory({"isManuallySelectingFile": true})}}>
                            Open Games Directory <span class="Legend">⌘O</span>
                        </div>
                        <div class="Option" onClick={this.onClickingSave()}>
                            Save <span class="Legend">⌘S</span>
                        </div>
                        <div class="Option" onClick={this.onClickingSave({"isManuallySelectingFile": true})}>
                            Save As... <span class="Legend">⌘⇧S</span>
                        </div>
                    </div>
                </div>
                <div class="Dropdown" onClick={this.onClickingFileMenu()} isFileMenuActive={Dev.isFileMenuActive}>
                    <div class="Dropbutton">
                        Edit
                    </div>
                    <div class="DropdownContent">
                        <div class="Option" onClick={this.onClickingUndo()}>
                            Undo <span class="Legend">⌘Z</span>
                        </div>
                        <div class="Option" onClick={this.onClickingRedo()}>
                            Redo <span class="Legend">⌘⇧Z</span>
                        </div>
                        <div class="Option" onClick={async () => {Dev.clipSelection(); Dev.deleteSelection()}}>
                            Cut <span class="Legend">⌘X</span>
                        </div>
                        <div class="Option" onClick={async () => {Dev.clipSelection()}}>
                            Copy <span class="Legend">⌘C</span>
                        </div>
                        <div class="Option" onClick={async () => {Dev.pasteSelection()}}>
                            Paste <span class="Legend">⌘V</span>
                        </div>
                    </div>
                </div>
                <div class="Dropdown" onClick={this.onClickingFileMenu()} isFileMenuActive={Dev.isFileMenuActive}>
                    <div class="Dropbutton">
                        View
                    </div>
                    <div class="DropdownContent">
                        <div class="Option" onClick={() => {Dev.areDevPanelsOpen = !Dev.areDevPanelsOpen}}>
                            Toggle panels <span class="Legend"> ` </span>
                        </div>
                        <div class="Option" onClick={() => {Dev.inProtoMode = !Dev.inProtoMode}}>
                            Toggle playtesting <span class="Legend"> = </span>
                        </div>
                        <div class="Option" onClick={() => {Dev.isRevealingSecretTiles = !Dev.isRevealingSecretTiles; Dev.redrawWorld()}}>
                            Toggle hiding secret tiles
                        </div>
                        <div class="HorizontalBreak"/>
                        <div class="Option" onClick={() => {Dev.changeMode("battle"); Dev.inProtoMode = true}}>
                            View battle editor <span class="Legend"> ⌘U </span>
                        </div>
                        <div class="Option" onClick={() => {Dev.changeMode("geography"); Dev.inProtoMode = true}}>
                            View geography editor <span class="Legend"> ⌘I </span>
                        </div>
                        <div class="Option" onClick={() => {Dev.changeMode("scripts"); Dev.inProtoMode = true}}>
                            View scripts editor <span class="Legend"> ⌘O </span>
                        </div>
                        <div class="HorizontalBreak"/>
                        <div class="Option" onClick={() => {window.location.search = "?playtest/"}}>
                            Go to Playtest
                        </div>
                        <div class="Option" onClick={() => {window.location.search = "?production/"}}>
                            Go to Production
                        </div>
                        <div class="Option" onClick={() => {window.location.search = "?development/"}}>
                            Go to Development
                        </div>
                    </div>
                </div>
                <div class="Dropdown" onClick={this.onClickingFileMenu()} isFileMenuActive={Dev.isFileMenuActive}>
                    <div class="Dropbutton">
                        Test
                    </div>
                    <div class="DropdownContent">
                        <div class="Option" onClick={() => {Dev.recordSavestate("j")}}>
                            Save Savestate J <span class="Legend">⌘⇧J</span>
                        </div>
                        <div class="Option" onClick={() => {Dev.recordSavestate("k")}}>
                            Save Savestate K <span class="Legend">⌘⇧K</span>
                        </div>
                        <div class="Option" onClick={() => {Dev.recordSavestate("l")}}>
                            Save Savestate L <span class="Legend">⌘⇧L</span>
                        </div>
                        <div class="HorizontalBreak"/>
                        <div class="Option" onClick={() => {Dev.reloadSavestate("j")}}>
                            Load Savestate J <span class="Legend">⌘J</span>
                        </div>
                        <div class="Option" onClick={() => {Dev.reloadSavestate("k")}}>
                            Load Savestate K <span class="Legend">⌘K</span>
                        </div>
                        <div class="Option" onClick={() => {Dev.reloadSavestate("l")}}>
                            Load Savestate L <span class="Legend">⌘L</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    onClickingFileMenu() {
        return () => {
            Dev.isFileMenuActive = !Dev.isFileMenuActive
        }
    }
    onClickingSave(options) {
        return () => {
            Dev.saveChapterToFolder(options)
        }
    }
    onClickingUndo() {
        return () => {
            if(Dev.inProtoMode == true) {
                Dev.loadProtostageDataToUndo()
            } else {
                App.game.chapter.actionTrace.push({"type": "undoAction"})
                Dev.recordSavestate("livePlaytest")
                App.game.chapter.undoAction()
            }
        }
    }
    onClickingRedo() {
        return () => {
            if(Dev.inProtoMode == true) {
                Dev.loadProtostageDataToRedo()
            }
        }
    }
}
